import { action, observable } from 'mobx'

export enum LoadingState {
  NOT_LOADED,
  LOADING,
  LOADED,
}

export default abstract class LoadableStore {
  @observable public state: LoadingState

  public constructor() {
    this.state = LoadingState.NOT_LOADED
  }

  public abstract load(): Promise<void>

  @action
  public async unload(): Promise<void> {
    this.state = LoadingState.NOT_LOADED
  }
}
